module.exports = __webpack_public_path__ + "48d4798fd4d7d001de103b22c509b8c0.png";